import { closeModal } from "../../utils/misc";
import { TODOS_MODAL_ID } from "./constants";

export const todoResolved = () => {
  document.dispatchEvent(new CustomEvent("coachTodo:resolved"));
  closeModal(TODOS_MODAL_ID);
};
